import { createContext } from 'react';

const FiltersContext = createContext<{ [key: string]: any }>({});

export default FiltersContext;
